import { createApp, type App } from 'vue';
import type { I18n } from 'vue-i18n';
import AgeRestrictionWidget from '@/widgets/AgeRestrictionWidget.vue';
import { AgeRestrictionKey } from '@/types/symbols';

const AGE_RESTRICTION_KEY = 'ageRestrictionConfirm';
type AgeRestrictionWidgetInstance = InstanceType<typeof AgeRestrictionWidget>;

const ageRestrictionPlugin = {
	install(
		app: App,
		options: {
			i18n: I18n;
		}
	) {
		const mountPoint = document.createElement('div');
		document.body.appendChild(mountPoint);
		const container = createApp(AgeRestrictionWidget)
			.use(options.i18n)
			.mount(mountPoint) as AgeRestrictionWidgetInstance;

		app.provide(AgeRestrictionKey, {
			validate: payload => {
				return new Promise(resolve => {
					const isConfirmed = sessionStorage.getItem(AGE_RESTRICTION_KEY);
					if (isConfirmed === 'true') {
						resolve(true);
						return;
					}

					container.setAnalyticsPayload(payload);
					container.setPromiseHandlers((value: boolean) => {
						sessionStorage.setItem(AGE_RESTRICTION_KEY, value.toString());
						resolve(value);
					});

					container.open();
				});
			}
		});
	}
};

export { ageRestrictionPlugin };
